module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTUgOSI+CiAgICA8cGF0aCBmaWxsPSIjODg4Qjk0IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC42MzQuMzY3YTEuMjQ5IDEuMjQ5IDAgMCAwLTEuNzY4IDBMNy41IDUuNzMzIDIuMTM0LjM2N0ExLjI0OSAxLjI0OSAwIDEgMCAuMzY3IDIuMTM0bDYuMjUgNi4yNWExLjI0OSAxLjI0OSAwIDAgMCAxLjc2NyAwbDYuMjUtNi4yNWExLjI0NyAxLjI0NyAwIDAgMCAwLTEuNzY3eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/down.svg
// module id = 96Ci
// module chunks = 0